



















































import Vue from 'vue'
import { Component, Prop, Watch, Emit } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import { dateTimeToDisplay, dateToDisplay } from '@/utils/dateTime'
import { Producer } from '@/modules/Producer/interfaces/producer'
import FoldingCard from '@/components/FoldingCard.vue'
import PolicyDialog from '../../Policy/scripts/policy-dialog'
import { policyStatus, policyStatusClass } from '@/modules/Policy/helpers/policy'
import dollarFilter from '@/utils/dollarFilter'

@Component({
  components: {
    FoldingCard
  }
})
export default class ProducerDetailPolicy extends mixins(PolicyDialog) {
  @Prop({ type: Object as () => Producer }) readonly producer!: Producer

  get policyList () {
    return this.producer.policies || []
  }

  tableColumn = [
    { field: 'policyNumber',
      title: 'Policy Number',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.policyNumber || '-')
        ]
      }
      },
      resizable: true
    },
    { field: 'policyName',
      title: 'Policy Name',
      slots: { default: 'name_default' },
      resizable: true
    },
    { field: 'status', title: 'Status', slots: { default: 'status_default' }, resizable: true },
    { field: 'carrierName',
      title: 'Carrier',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.carrier ? row.carrier.name : '-')
        ]
      }
      },
      resizable: true
    },
    { field: 'premium',
      title: 'Premium',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.premium ? dollarFilter(row.premium) : '-')
        ]
      }
      },
      resizable: true
    },
    { field: 'effectiveDate',
      title: 'Effcetive Date',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.effectiveDate ? dateToDisplay(row.effectiveDate) : '-')
        ]
      }
      },
      resizable: true
    },
    { field: 'expirationDate',
      title: 'Expiration Date',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.expirationDate ? dateToDisplay(row.expirationDate) : '-')
        ]
      }
      }
    },
    { field: 'actions', title: 'Actions', slots: { default: 'action_default' }, fixed: 'right', width: 90 }
  ]

  dateTimeToDisplay = dateTimeToDisplay
  dateToDisplay = dateToDisplay
  policyStatus = policyStatus
  policyStatusClass = policyStatusClass

  @Emit('success')
  onSuccess () {
    // do nothing
  }

  routeToDetail (item: any) {
    this.$router.push({
      name: 'PolicyDetailDetail',
      params: {
        id: item.id
      }
    })
  }

  async deletePolicyConfirm () {
    await this.deletePolicyPost()
    this.onSuccess()
  }

  routeToAllList () {
    this.$router.push({
      name: 'ProducerRelatedPoliciesList',
      params: {
        id: this.producer.id + '',
        fromName: this.producer.name
      }
    })
  }
}
